import { Box } from '@rbilabs/universal-components';

import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { primitive } from 'styles/constants/primitives';

export const FADE_IN_ANIMATION_MILLIS = 700;
export const SLIDE_IN_ANIMATION_MILLIS = 300;

export const SelectorContainer = Box.withConfig({
  width: 'full',
});

export interface SelectorItemProps {
  selected: boolean;
}

export const productDetailFlowContainerStyles: any = {
  flex: 1,
  width: '100%',
};

export const ProductDetailFlowContent = Box.withConfig({
  flex: 1,
  width: 'full',
});

export const getBackgroundColorByStep = (step: ProductWizardStep) =>
  step === ProductWizardStep.ProductHome || step === ProductWizardStep.PickerReview
    ? primitive.bk.$mayoEggWhite
    : primitive.$white;
